const CustomDatapicker = {
  custom: 'Власний діапазон',
  custom_medium: 'Інший',
  shortcuts: {
    text: {
      'week': 'Тиждень',
      '1month': '1 місяць',
      '3months': '3 місяці'
    },
    text_short: {
      'week': '7д',
      '1month': '1м',
      '3months': '3м'
    }
  },
  tooltips: {
    'custom': 'Власний діапазон',
    'week': 'Тиждень',
    '1month': '1 місяць',
    '3months': '3 місяці'
  },
};

export default CustomDatapicker;
